import {autoserializeAs, autoserializeAsArray} from "dcerialize";

export enum ReferenceDetailsKind {
  FeatureList = "featureList",
}

export class ReferenceDetails {
  @autoserializeAs(() => String)
  public readonly kind: ReferenceDetailsKind;
  @autoserializeAsArray(() => String)
  public readonly features: readonly string[];
}
